var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.673 8.732)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 7.654,
    y2: 7.536
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 7.536,
    x2: 7.654
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.ead406bedf12af9496e79e8d622634d3.svg";
export { ForwardRef as ReactComponent };